<template>
  <div>包装后OBA抽检</div>
</template>

<script>
export default {
  name: "CheckAfterPack"
}
</script>

<style scoped>

</style>